export function getLocale(loc: string | undefined): Localize {
    switch (loc?.toLowerCase()) {
        case 'da':
            return {
                WEEKDAYS_LONG: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                WEEKDAYS_SHORT: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                DAYS_SHORT: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                MONTHS: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                DAYS_MIN: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
                MONTHS_SHORT: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'I dag',
                PM: 'PM',
                AM: 'AM'
            };
        case 'nl':
            return {
                WEEKDAYS_LONG: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
                WEEKDAYS_SHORT: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
                DAYS_SHORT: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
                MONTHS: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
                DAYS_MIN: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
                MONTHS_SHORT: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Vandaag',
                PM: 'PM',
                AM: 'AM'
            };
        case 'de':
            return {
                WEEKDAYS_LONG: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                WEEKDAYS_SHORT: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                DAYS_SHORT: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                MONTHS: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                DAYS_MIN: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                MONTHS_SHORT: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Heute',
                PM: 'PM',
                AM: 'AM'
            };
        case 'fr':
            return {
                WEEKDAYS_LONG: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                WEEKDAYS_SHORT: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                DAYS_SHORT: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
                MONTHS: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                DAYS_MIN: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
                MONTHS_SHORT: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: "Aujourd'hui",
                PM: 'PM',
                AM: 'AM'
            };
        case 'sv':
            return {
                WEEKDAYS_LONG: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
                WEEKDAYS_SHORT: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
                DAYS_SHORT: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
                MONTHS: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
                DAYS_MIN: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
                MONTHS_SHORT: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'I dag',
                PM: 'PM',
                AM: 'AM'
            };
        //            fix bug 14217: ResourceFinder: Do not display chinese on Datepicker when changing Resource Finder language to Chinese
        case 'zh-cn':
            return {
                WEEKDAYS_LONG: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
                WEEKDAYS_SHORT: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                DAYS_SHORT: ['日', '一', '二', '三', '四', '五', '六'],
                MONTHS: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                DAYS_MIN: ['日', '一', '二', '三', '四', '五', '六'],
                MONTHS_SHORT: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: '今日',
                PM: '下午',
                AM: '上午'
            };
        case 'es':
            return {
                WEEKDAYS_LONG: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                WEEKDAYS_SHORT: ['Dom', 'Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb'],
                DAYS_SHORT: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
                MONTHS: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                DAYS_MIN: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
                MONTHS_SHORT: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Hoy',
                PM: 'PM',
                AM: 'AM'
            };
        case 'ja':
            return {
                WEEKDAYS_LONG: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
                WEEKDAYS_SHORT: ['日', '月', '火', '水', '木', '金', '土'],
                DAYS_SHORT: ['日', '月', '火', '水', '木', '金', '土'],
                MONTHS: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                DAYS_MIN: ['日', '月', '火', '水', '木', '金', '土'],
                MONTHS_SHORT: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: '今日',
                PM: '午後',
                AM: '午前'
            };
        case 'pt':
            return {
                WEEKDAYS_LONG: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sabado'],
                WEEKDAYS_SHORT: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
                DAYS_SHORT: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
                MONTHS: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                DAYS_MIN: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
                MONTHS_SHORT: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Hoje',
                PM: 'PM',
                AM: 'AM'
            };
        case 'ru':
            return {
                WEEKDAYS_LONG: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
                WEEKDAYS_SHORT: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
                DAYS_SHORT: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                MONTHS: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                DAYS_MIN: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                MONTHS_SHORT: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Сегодня',
                PM: 'После полудня',
                AM: 'До полудня'
            };
        case 'ko':
            return {
                WEEKDAYS_LONG: ['일', '월', '화', '수', '목', '금', '토'],
                WEEKDAYS_SHORT: ['일', '월', '화', '수', '목', '금', '토'],
                DAYS_SHORT: ['일', '월', '화', '수', '목', '금', '토'],
                MONTHS: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                DAYS_MIN: ['일', '월', '화', '수', '목', '금', '토'],
                MONTHS_SHORT: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: '오늘',
                PM: '오후',
                AM: '오전'
            };
        //            end fix bug 14217:
        //Hungnn SBI 628: RC must include the Finnish language in frontend, backend and outlook add-in
        case 'fi':
            return {
                WEEKDAYS_LONG: ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'],
                WEEKDAYS_SHORT: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
                DAYS_SHORT: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
                MONTHS: ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu', 'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'],
                DAYS_MIN: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
                MONTHS_SHORT: ['Tammi', 'Helmi', 'Maalis', 'Huhti', 'Touko', 'Kes&auml;', 'Hein&auml;', 'Elo', 'Syys', 'Loka', 'Marras', 'Joulu'],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Tänään',
                PM: 'IP',
                AM: 'AP'
            };
        //end SBI 628
        //Hungnn fix 2173: Italian- ResourceFinder:  a few items have not yet shown in Italian
        case 'it':
            return {
                WEEKDAYS_LONG: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
                WEEKDAYS_SHORT: ["Do.", "Lu.", "Ma.", "Me.", "Gi.", "Ve.", "Sa."],
                DAYS_SHORT: ["Do.", "Lu.", "Ma.", "Me.", "Gi.", "Ve.", "Sa."],
                MONTHS: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
                DAYS_MIN: ["Do.", "Lu.", "Ma.", "Me.", "Gi.", "Ve.", "Sa."],
                MONTHS_SHORT: ["Gen.", "Feb.", "Mar.", "Apr.", "Mag.", "Giu.", "Lug.", "Ago.", "Set.", "Ott.", "Nov.", "Dic."],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Oggi',
                PM: 'PM',
                AM: 'AM'
            };
        //end 2173
        case 'nb':
            return {
                WEEKDAYS_LONG: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
                WEEKDAYS_SHORT: ["søn", "Man", "tir", "ons", "tor", "fre", "Lør"],
                DAYS_SHORT: ["søn", "Man", "tir", "ons", "tor", "fre", "Lør"],
                MONTHS: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"],
                DAYS_MIN: ["søn", "Man", "tir", "ons", "tor", "fre", "Lør"],
                MONTHS_SHORT: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'I dag',
                PM: 'PM',
                AM: 'AM'
            };
        case 'cy':
            return {
                WEEKDAYS_LONG: ["Dydd Sul", "Dydd Llun", "Dydd Mawrth", "Dydd Mercher", "Dydd Iau", "Dydd Gwener", "Dydd Sadwrn"],
                WEEKDAYS_SHORT: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
                DAYS_SHORT: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
                MONTHS: ["Ionawr", "Chwefror", "Mawrth", "Ebrill", "Mai", "Mehefin", "Gorffennaf", "Awst", "Medi", "Hydref", "Tachwedd", "Rhagfyr"],
                DAYS_MIN: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
                MONTHS_SHORT: ["Ion", "Chwe", "Maw", "Ebr", "Mai", "Meh", "Gorff", "Awst", "Medi", "Hyd", "Tach", "Rhag"],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Heddiw',
                PM: 'yh',
                AM: 'yb'
            };
        case 'pl-pl': //polish
            return {
                WEEKDAYS_LONG: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
                WEEKDAYS_SHORT: ["Nie", "Pn", "Wt", "Śr", "Czw", "Pt", "So"],
                DAYS_SHORT: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
                MONTHS: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
                DAYS_MIN: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
                MONTHS_SHORT: ["Sty", "Lu", "Mar", "Kw", "Maj", "Cze", "Lip", "Sie", "Wrz", "Pa", "Lis", "Gru"],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Heddiw',
                PM: 'PM',
                AM: 'AM'
            };
        case 'cs-cz': //Czech
            return {
                WEEKDAYS_LONG: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"],
                WEEKDAYS_SHORT: ["ne", "po", "út", "st", "čt", "pá", "so"],
                DAYS_SHORT: ["ne", "po", "út", "st", "čt", "pá", "so"],
                MONTHS: ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"],
                DAYS_MIN: ["ne", "po", "út", "st", "čt", "pá", "so"],
                MONTHS_SHORT: ["led", "úno", "bře", "dub", "kvě", "čer", "čvc", "srp", "zář", "říj", "lis", "pro"],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Nyní',
                PM: 'PM',
                AM: 'AM'
            };
        default:
            return {
                WEEKDAYS_LONG: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                WEEKDAYS_SHORT: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                DAYS_SHORT: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                MONTHS: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                DAYS_MIN: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                MONTHS_SHORT: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                FIRST_DAY_OF_WEEK: 1,
                TO_DAY_LABEL: 'Today',
                PM: 'PM',
                AM: 'AM'
            };
    }
}
export interface Localize {
    WEEKDAYS_LONG: [string, string, string, string, string, string, string];
    WEEKDAYS_SHORT: [string, string, string, string, string, string, string];
    DAYS_SHORT: [string, string, string, string, string, string, string];
    MONTHS: [string, string, string, string, string, string, string, string, string, string, string, string];
    DAYS_MIN: [string, string, string, string, string, string, string];
    MONTHS_SHORT: [string, string, string, string, string, string, string, string, string, string, string, string];
    FIRST_DAY_OF_WEEK: number;
    TO_DAY_LABEL: string;
    AM: string;
    PM: string;
}